import axios from "axios";

export function getAthlete(s: string = '', club: string = '', team: string = '', season: string = '', sortbyfield: string = 'changed_at', sortbytype: string = 'DESC', page: number = 1, per_page: number = 12) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete';
    const params = [];
    if (s.length > 0) {
        params.push('s=' + s);
    }
    if (club.length > 0) {
        params.push('club=' + club);
    }
    if (team.length > 0) {
        params.push('team=' + team);
    }
    if (season.length > 0) {
        params.push('season=' + season);
    }
    if (sortbyfield.length > 0) {
        params.push('sortbyfield=' + sortbyfield);
    }
    if (sortbytype.length > 0) {
        params.push('sortbytype=' + sortbytype);
    }
    params.push('page=' + page);
    params.push('per_page=' + per_page);
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getAthleteOptions(club_id: string = '') {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete/options';
    if (club_id.length > 0) {
        endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete/options?club_id=' + club_id;
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getAthleteSingle(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const getEventsUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete/' + id;
    return axios.get(getEventsUrl, { headers: headers } );
}

export function createAthlete(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateAthlete(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteAthlete(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}

export function getAthleteTeamSeason(athlete_id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete-team-season/' + athlete_id;
    return axios.get(endpointUrl, { headers: headers });
}

export function getTeamSeasonAthletes(team_id: number, season_id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/team-season-athletes/' + team_id + '/' + season_id;
    return axios.get(endpointUrl, { headers: headers });
}

export function createAthleteTeamSeason(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete-team-season';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteAthleteTeamSeason(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete-team-season/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}

export function getAthleteMeasurement(athlete_id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete-measurement/' + athlete_id;
    return axios.get(endpointUrl, { headers: headers });
}

export function createAthleteMeasurement(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete-measurement';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteAthleteMeasurement(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete-measurement/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}

export function getAthleteRanking(athlete_id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete-ranking/' + athlete_id;
    return axios.get(endpointUrl, { headers: headers });
}

export function createAthleteRanking(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete-ranking';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteAthleteRanking(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete-ranking/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}

export function getGlobalAthleteRanking() {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/global-athlete-ranking';
    return axios.get(endpointUrl, { headers: headers });
}

export function getAthletePerformance(athlete_id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete-performance/' + athlete_id;
    return axios.get(endpointUrl, { headers: headers });
}

export function createAthletePerformance(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete-performance';
    return axios.post(endpointUrl, body_obj, { headers: headers });
}

export function createBulkAthletePerformance(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete-performance-bulk';
    return axios.post(endpointUrl, body_obj, { headers: headers });
}

export function deleteAthletePerformance(id: number | string) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/athlete-performance/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}

export function getGlobalAthletePerformance() {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/global-athlete-performance';
    return axios.get(endpointUrl, { headers: headers });
}

/*export function getAthleteAcitivities(user_id: string) {
    const token = localStorage.getItem('token');
    const headers = {
        'x-api-key': '47Pcasd2a3DYx6dw5wBAc1XeOmJ0Wz4enzD0KIQpIp4mAmzUKf42',
        'Content-Type': 'application/json'
    }
    const body_obj = {
        userids: [user_id]
    }
    let endpointUrl = 'https://gapi.cristalizaservicios.es/v1/query/paddletech/activity/bydeviceids';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}*/

export function getAthleteAcitivities(userIds: string[] = [], from: string = '', to: string = '', metric: string = 'activities', activityType: string = '') {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const body_obj = {
        userIds: userIds,
        from: from,
        to: to,
        metric: metric,
        activityType: activityType
    };
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/activities';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function getAthleteAcitivityDetails(userId: string, activityId: string) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const body_obj = {
        userId: userId,
        activityId: activityId
    };
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/one-activity';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}